import type { CSSProperties } from 'react';
import { colorWithAlpha } from '@/utils/colorWithAlpha';

/** CSS variables for `MarketplaceTabs.module.css` (accent = qrCodeColor / brand). */
export function getMarketplaceTabStyleVars(accentColor: string): CSSProperties {
  return {
    '--tab-accent': accentColor,
    '--tab-active-bg': colorWithAlpha(accentColor, 0.1),
    '--tab-active-border': colorWithAlpha(accentColor, 0.3),
    '--tab-hover-bg': colorWithAlpha(accentColor, 0.05),
    '--tab-hover-border': colorWithAlpha(accentColor, 0.16),
    '--tab-count-active-border': colorWithAlpha(accentColor, 0.2),
  } as CSSProperties;
}

/** Toolbar chips — accent outline; background follows theme via CSS module. */
export function getMarketplaceToolbarStyleVars(accentColor: string): CSSProperties {
  return {
    '--tab-accent': accentColor,
    '--toolbar-border': colorWithAlpha(accentColor, 0.32),
    '--toolbar-hover-bg': colorWithAlpha(accentColor, 0.06),
    '--toolbar-hover-border': colorWithAlpha(accentColor, 0.45),
    '--toolbar-active-bg': colorWithAlpha(accentColor, 0.11),
    '--toolbar-active-border': colorWithAlpha(accentColor, 0.58),
    '--toolbar-badge-bg': colorWithAlpha(accentColor, 0.12),
    '--toolbar-badge-border': colorWithAlpha(accentColor, 0.28),
  } as CSSProperties;
}
